import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { getReportAgesForMultiSelect, getReportDefaultGendersForMultiSelect } from '../../../../../../../helpers/multiselect/multiselect';
import { School } from '../../../../../../../models/school';
import { SchoolForm } from '../../../../../../../models/form';
import { ReportActions, ReportCheckboxGrid, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../SchoolLeagues.css';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; school: School; forms: SchoolForm[]; }

export function AggregatedTargetCompletionReportForm({ onCloseClick, onSubmit, school, forms }: Props) {
  const initialValues = { isShowCompleted: true, isShowUncompleted: true, isShowBlank: true, genders: getReportDefaultGendersForMultiSelect(), ages: getReportAgesForMultiSelect(school, forms), isSelectAllAges: true };
  return (
    <Formik initialValues={initialValues} onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.AGGREGATED_TARGET_COMPLETION)}>
      {({ values, setFieldValue }) => {
        const toggleItem = (field: 'genders' | 'ages', index: number) => {
          const next = values[field].map((item, itemIndex) => itemIndex === index ? { ...item, isChecked: !item.isChecked } : item);
          setFieldValue(field, next);
          if (field === 'ages') setFieldValue('isSelectAllAges', next.every(item => item.isChecked));
        };
        const valid = values.genders.some(item => item.isChecked) && values.ages.some(item => item.isChecked);
        return (
          <Form className="eReportForm">
            <div className="eReportForm__scroll">
              <ReportDescription>Review target completion across the selected leagues and chosen student groups.</ReportDescription>
              <ReportSection number={1} title="Target states" hint="Choose which target states appear in the report.">
                <ReportToggleList>
                  <ReportToggle name="isShowCompleted" label="Completed targets" hint="Include targets marked as completed." value={values.isShowCompleted} onChange={value => setFieldValue('isShowCompleted', value)} />
                  <ReportToggle name="isShowUncompleted" label="Incomplete targets" hint="Include targets that have not been completed." value={values.isShowUncompleted} onChange={value => setFieldValue('isShowUncompleted', value)} />
                  <ReportToggle name="isShowBlank" label="Non-participants" hint="Include matching students who were not added to the selected activities." value={values.isShowBlank} onChange={value => setFieldValue('isShowBlank', value)} />
                </ReportToggleList>
              </ReportSection>
              <ReportSection number={2} title="Gender" hint="Select one or more genders to include." required>
                <ReportCheckboxGrid items={values.genders} onChange={index => toggleItem('genders', index)} />
              </ReportSection>
              <ReportSection number={3} title="Age groups" hint="Age groups are arranged by key stage." required>
                <ReportToggle name="isSelectAllAges" label="Select all ages" hint="Include every available age group." value={values.isSelectAllAges} onChange={checked => { setFieldValue('isSelectAllAges', checked); setFieldValue('ages', values.ages.map(item => ({ ...item, isChecked: checked }))); }} />
                <div className="eReportSection__chips"><ReportCheckboxGrid items={values.ages} onChange={index => toggleItem('ages', index)} /></div>
              </ReportSection>
            </div>
            <ReportActions onCancel={onCloseClick} disabled={!valid} />
          </Form>
        );
      }}
    </Formik>
  );
}
